module.exports = __webpack_public_path__ + "static/0049-56500355f6491d663030a6850fb15630.png";